import { api } from "../api";


const BASE_URL = "/announcements";

export const getEventsById = (id) => {
  return api.get(`${BASE_URL}/${id}`);
};
